import {
	Component,
	ElementRef,
	Input,
	TemplateRef
} from '@angular/core';

@Component( {
	selector: 'app-page-base',
	templateUrl: './page-base.component.html',
	styleUrls: [ './page-base.component.scss' ]
} )
export class PageBaseComponent {

	@Input() pageTitle: string;

	@Input() pageActionTemplate: TemplateRef<ElementRef>;

	@Input() contentTemplates: TemplateRef<ElementRef>[];

	@Input() stickyContentTemplates: TemplateRef<ElementRef>[];

	constructor() {}
}
